import { useCallback, useMemo } from 'react';

import {
	type BaseAIAction,
	type SourceAIActions,
	useSourceAIActions,
} from '@atlassian/ai-smart-button-api';

import { useAIActions } from './useAIActions';

export const EDITOR_AI_ACTION_SOURCE_ID = 'editor';

export const useCreateEditorRovoButtonActions = (): SourceAIActions => {
	const aiRovoButtonActions = useSourceAIActions(EDITOR_AI_ACTION_SOURCE_ID);
	const { setEditorActions } = useAIActions();

	const newSetActions = useCallback(
		(actions: BaseAIAction[]) => {
			aiRovoButtonActions.setActions(actions);
			setEditorActions(actions);
		},
		[aiRovoButtonActions, setEditorActions],
	);

	const newRemoveAll = useCallback(() => {
		aiRovoButtonActions.removeAll();
		setEditorActions([]);
	}, [aiRovoButtonActions, setEditorActions]);

	return useMemo(() => {
		return {
			...aiRovoButtonActions,
			setActions: newSetActions,
			removeAll: newRemoveAll,
		};
	}, [aiRovoButtonActions, newSetActions, newRemoveAll]);
};
